import { useEffect, useMemo, useState } from 'react';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HighlightOffIcon from '@mui/icons-material/HighlightOff';
//MRT Imports
import {
  MaterialReactTable,
  useMaterialReactTable,
} from 'material-react-table';
import { MRT_Localization_FR } from 'material-react-table/locales/fr';

//Material UI Imports
import {
  Box,
  Tooltip,
} from '@mui/material';
import { useOrganizationSelect } from '../../../context/OrganizationSelectContext';
import { useSelector } from 'react-redux';
import PageHeader from '../../../components/common/PageHeader';

   


const EsetDevices = () => {

  const [filteredEsetDevices, setfilteredEsetDevices] = useState([]);

  const { data: esetDevices = [], loading, error } = useSelector((state) => state.eset.devices);
  const { selectedOrganization } = useOrganizationSelect();


  useEffect(() => {
    if (selectedOrganization) {
      setfilteredEsetDevices(esetDevices.filter(
        (item) => item.organizationName === selectedOrganization
      ));
  } else {
    setfilteredEsetDevices(esetDevices);
  }
  }, [selectedOrganization, esetDevices]);


    const columns = useMemo(
      () => [
        {
          id: 'devices', //id used to define `group` column
          columns: [
            {
              accessorFn: (row) => row.name, //accessorFn used to join multiple data into a single cell
              id: 'name', //id is still required when using accessorFn instead of accessorKey
              header: 'Nom',
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) => row.hardware[0]?.serialNumber || '',
              id: 'serialNumber',
              header: 'N° Série',
              size: 120,
              Cell: ({ renderedCellValue }) => (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: '1rem' }}>
                  {renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorKey: 'ipLAN', //hey a simple column for once
              header: 'IP LAN',
              size: 50,
            },
            {
              accessorKey: 'ipWAN', //hey a simple column for once
              header: 'IP WAN',
              size: 50,
            },
            {
              accessorFn: (row) =>
                row.lastSync
                  && new Date(row.lastSync).toLocaleString('fr-FR', { timeZone: 'UTC' })
                  ,
              id: 'lastSync',
              header: 'Dernière Synchronisation',
              size: 250,
              Cell: ({ row }) => {
                const lastSyncDate = row.original.lastSync ? new Date(row.original.lastSync) : null;
                const currentDate = new Date();
            
                let diffDays = 0;
                if (lastSyncDate) {
                  const diffTime = currentDate.getTime() - lastSyncDate.getTime();
                  diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));
                }
            
                const formattedDate = lastSyncDate
                  ? lastSyncDate.toLocaleString('fr-FR', { timeZone: 'UTC' })
                  : 'Non synchronisé';
            
                let color = 'inherit';
                let icon = null;
            
                if (diffDays > 30) {
                  color = 'red';
                  icon = (
                    <Tooltip title="Dernière synchronisation il y a plus de 60 jours">
                      <ErrorOutlineIcon fontSize="small" color="error" />
                    </Tooltip>
                  );
                } else if (diffDays > 10) {
                  color = 'orange';
                  icon = (
                    <Tooltip title="Dernière synchronisation il y a plus de 30 jours">
                      <WarningAmberIcon fontSize="small" sx={{ color: 'orange' }} />
                    </Tooltip>
                  );
                }
            
                return (
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                    <span style={{ color }}>{formattedDate}</span>
                    {icon}
                  </Box>
                );
              },
                },
                {
                  accessorFn: (row) => row.organizationDetails?.name, //accessorFn used to join multiple data into a single cell
              id: 'organization', //id is still required when using accessorFn instead of accessorKey
              header: 'Client',
              size: 250,
              Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
              ),
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) => row.tenantName || '',
              id: 'tenantName',
              header: 'Tenant ESET',
              size: 220,
              filterVariant: 'autocomplete',
            },
            {
              accessorFn: (row) => row.components.map((component) => component.name).join('\n'), //accessorFn used to join multiple data into a single cell
              id: 'components', //id is still required when using accessorFn instead of accessorKey
                header: 'Composants',
                size: 250,
                Cell: ({ renderedCellValue, row }) => (
                <Box
                  sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  }}
                >{renderedCellValue}
                </Box>
                ),
                filterVariant: 'autocomplete',
              },
              {
                accessorFn: (row) => row.deleted ? "Yes" : "No", //accessorFn used to join multiple data into a single cell
                id: 'deleted', //id is still required when using accessorFn instead of accessorKey
                header: 'Supprimé',
                size: 100,
                Cell: ({ row }) => (
                  <Box
                  sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem',
                  }}
                  >
                  {row.original.deleted ? (
                  <Tooltip title={row.original.deleted ? `Supprimé le ${new Date(row.original.deleted).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit', timeZone: 'UTC' })}` : "No expiration date"} >
                    <HighlightOffIcon color="error" />
                  </Tooltip>
                  ) : (
                    <></>
                  )}
                  </Box>
                ),
                filterVariant: 'autocomplete',

            //   id: 'deleted', //id is still required when using accessorFn instead of accessorKey
            //   header: 'Supprimé',
            //   size: 250,
            //   Cell: ({ renderedCellValue, row }) => (
            //     <Box
            //       sx={{
            //         display: 'flex',
            //         alignItems: 'center',
            //         gap: '1rem',
            //       }}
            //     >{renderedCellValue}
            //     </Box>
            //   ),
            },
          ]}
      ],
      [],
    );
    
  
    const table = useMaterialReactTable({
    localization: MRT_Localization_FR,
    enableGlobalFilter: true,
    enableColumnFilters: true,

      columns,
      data: filteredEsetDevices ? filteredEsetDevices : null, //data must be memoized or stable (useState, useMemo, defined outside of this component, etc.)
      enableColumnFilterModes: true,
      enableColumnOrdering: true,
      enableGrouping: true,
      enableColumnPinning: true,
      enableFacetedValues: true,
      initialState: {
        density:"compact",
        showColumnFilters: true,
        showGlobalFilter: true,
        columnPinning: {
          left: ['mrt-row-expand', 'mrt-row-select'],
          right: ['mrt-row-actions'],
        },
        pagination: {
          pageSize: 50,

        }
      },
      paginationDisplayMode: 'pages',
      positionToolbarAlertBanner: 'bottom',
      muiSearchTextFieldProps: {
        size: 'small',
        variant: 'outlined',
      },
      muiPaginationProps: {
        color: 'secondary',
        rowsPerPageOptions: [50, 100, 150],
        shape: 'rounded',
        variant: 'outlined',
      },
    });
  
  
    return  (
      <Box>
        <PageHeader section="ESET" title="Appareils" sx={{ my: 2 }} />
        <Box>
          <MaterialReactTable table={table} />
        </Box>

      </Box>
      )};

export default EsetDevices;
